import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL_TREE_PERMIT_FORM;
const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

export default {
  healthCheck() {
    return httpClient.get(baseUrl);
  },
  fetchConfiguration(){
    return httpClient.get(`${baseUrl}configuration`);
  },
  fetchDevelopmentApplicationFileList(){
    return httpClient.get(`${baseUrl}developmenttypes`);
  },
  createTreePermit(payload) {
    return httpClient.post(`${baseUrl}create`, payload, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  }
};
